'use client';

import { useEffect, useState } from 'react';

interface ConditionalMainProps {
  children: React.ReactNode;
}

export function ConditionalMain({ children }: ConditionalMainProps) {
  const [isSubdomain, setIsSubdomain] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if we're on a subdomain
    const hostname = window.location.hostname;
    const isNotesSubdomain = hostname.startsWith('notes.') || 
                            hostname.includes('.notes.') ||
                            (hostname.includes('localhost') && window.location.pathname.startsWith('/notes'));
    const isAuthSubdomain = hostname.startsWith('auth.') || 
                           hostname.includes('.auth.') ||
                           (hostname.includes('localhost') && window.location.pathname.startsWith('/auth'));
    const isLearnSubdomain = hostname.startsWith('learn.') ||
      hostname.includes('.learn.') ||
      (hostname.includes('localhost') && window.location.pathname.startsWith('/learn'));

    setIsSubdomain(isNotesSubdomain || isAuthSubdomain || isLearnSubdomain);
    setIsLoading(false);
  }, []);

  // Use different padding based on whether we're on a subdomain
  const mainClassName = isSubdomain 
    ? "min-h-screen" // No top padding on subdomain (no navbar)
    : "min-h-screen pt-16"; // Top padding on main domain (for navbar)

  return (
    <main className={mainClassName}>
      {children}
    </main>
  );
}
